import $ from 'jquery'

/**
 * Initialize the bubbles
 */
const init = () => {

  const $panel   = $( '.your-chat__panel' )  .first(),
        $bubble  = $( '.your-chat__bubble' ) .first()

  setTimeout( () => $bubble.removeClass( 'hidden' ), 30 )

  $bubble.click( () => {
    $bubble .addClass( 'activated' )
    $panel  .addClass( 'activated' )
  } )

}

export default () => init()
